import PatientHome from '../views/PatientHome';
import { useContext } from 'react';
import { UserContext } from '../context/userContext';
import { ROLE } from '../interface/interface';
import DoctorHome from '../views/DoctorHome';
import Home from '../views/Home';

const RenderHome = () => {
  const { userDetail } = useContext(UserContext);
  if (!userDetail) return <></>;

  const getHomeComponent = () => {
    switch (userDetail.role) {
      case ROLE.Patients:
        return <PatientHome />;
      case ROLE.Doctors:
        return <DoctorHome />;
      default:
        return <Home />;
    }
  };

  return <>{getHomeComponent()}</>;
};

export default RenderHome;
